/*
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2022-03-02 15:28:27
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2024-05-09 16:13:53
 * @FilePath: /visaai-platform/src/plugins/store/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE,
 */
import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import userInfo from './modules/userInfo'
import balance from './modules/balance'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    userInfo,
    balance,
  }
})
